// Maps between API names (vehicles, car) and url routes (auto-moto, osobni-automobili)
// using the modules / categories loaded into the global store.
import { selectCategories, selectModules } from "../containers/App/selectors";
import store from "../store";

export const mapCategoryToHr = (category, module = null) => {
  const state = store.getState();
  const categories = selectCategories(state);

  let returnCategory = category;

  if (module) {
    categories.forEach(c => {
      if (
        (c.moduleName === module || c.moduleRoute === module) &&
        (c.name == category || c.route === category)
      ) {
        returnCategory = c.route
      }
    })
  } else {
    categories.forEach(c => {
      if (c.name == category) {
        returnCategory = c.route
      }
    })
  }


  return returnCategory
};

export const doesCategoryExist = (category, module = null) => {


  const state = store.getState();
  const categories = selectCategories(state);

  let returnCategory = false;

  if (module) {
    categories.forEach(c => {
      if (
        (c.moduleName === module || c.moduleRoute === module) &&
        (c.name == category || c.route === category)
      ) {
        returnCategory = true
      }
    })
  } else {
    categories.forEach(c => {
      if (c.name == category || c.route === category) {
        returnCategory = true
      }
    })
  }


  return returnCategory
};

export const mapModuleToHr = module => {
  const state = store.getState()
  const modules = selectModules(state)

  let returnModule = module;

  modules.forEach(m => {
    if (m.name === module) {
      returnModule = m.route
    }
  });

  return returnModule;
};

export const mapModuleToEn = module => {
  const state = store.getState()
  const modules = selectModules(state)

  let returnModule = module;

  modules.forEach(m => {
    if (m.route == module) {
      returnModule = m.name;
    }
  });

  return returnModule;
};

export const mapCategoryToEn = (category, module = null) => {
  const state = store.getState();
  const categories = selectCategories(state);
  let returnCategory = category;

  if (module) {
    categories.forEach(c => {
      if (
        c.route === category &&
        (c.moduleRoute === module || c.moduleName == module)
      ) {
        returnCategory = c.name;
      }
    });
  } else {
    categories.forEach(c => {
      if (c.route === category) {
        returnCategory = c.name;
      }
    });
  }

  return returnCategory;
};

export const mapModulesAndCategories = data => {
  const state = store.getState();
  const categories = selectCategories(state);

  let localData = { ...data };
  categories.forEach(c => {
    if (c.moduleRoute == data.module) {
      localData = { ...localData, module: c.moduleName };
    }

    if (
      c.route == data.category &&
      (c.moduleRoute == data.module || c.moduleName == data.module)
    ) {
      localData = { ...localData, category: c.name };
    } else if (!data.module) {
      if (c.route == data.category) {
        localData = { ...localData, category: c.name };
      }
    }
  });

  return localData;
};



// WEBPACK FOOTER //
// ./src/routes/LanguageMapper.ts